<div [formGroup]="form">

  <div *ngIf="isLoading; else loaded" class="text-center my-3">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-2">Cargando información...</p>
  </div>

  <ng-template #loaded>

    <div class="row">
      <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
        <h5 class="mt-2 mb-2">
          Usuario
        </h5>
        <div class="row">
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Correo electrónico</label>
              @if(isViewMode) {
                <div class="form-control-plaintext">
                  {{ form.get('email')?.value || 'No especificado' }}
                </div>
              } @else {
                <div class="input-group">
                  @if(isEditMode){
                    <input [value]="form.get('email')?.value" disabled type="email" class="form-control" />
                  }@else {
                    <input formControlName="email" type="email" class="form-control" />
                  }
                  <span class="input-group-text">
                    <i 
                      *ngIf="form.get('email')?.valid && form.get('email')?.value" 
                      class="fa-solid fa-circle-check text-success">
                    </i>
                    <i 
                      *ngIf="form.get('email')?.invalid && form.get('email')?.touched" 
                      class="fa-solid fa-circle-xmark text-danger">
                    </i>
                  </span>
                </div>
                <app-form-errors [controlName]="form.controls['email']"></app-form-errors>
              }
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Página web</label>
              @if(isViewMode) {
                <div class="form-control-plaintext">
                  {{ form.get('website')?.value || 'No especificado' }}
                </div>
              } @else {
                <div>
                  <input formControlName="website" type="url" class="form-control" />
                </div>
                <app-form-errors [controlName]="form.controls['website']"></app-form-errors>
              }
            </div>
          </div>

          <!-- Sección para cambio de credenciales en modo edición -->
          <div class="row" *ngIf="isEditMode && !isViewMode">
            <div class="col-12 mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="changePassword" id="changePasswordCheckbox">
                <label class="form-check-label" for="changePasswordCheckbox">
                  Deseo cambiar mi contraseña
                </label>
              </div>
            </div>

            <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12" *ngIf="wantToChangePassword">
              <div class="form-group mb-3">
                <label class="required-field">Nueva contraseña</label>
                <div>
                  <input formControlName="password" type="password" class="form-control" />
                </div>
                <!-- Requisitos de contraseña -->
                <div class="password-requirements mt-2" [ngClass]="{'text-danger': form.controls['password'].dirty && form.controls['password'].invalid}">
                  <small>
                    La contraseña debe cumplir los siguientes requisitos:
                  </small>
                  <ul class="small mt-1 ps-3">
                    <li *ngIf="form.controls['password'].dirty && (!form.controls['password'].value || form.controls['password'].value.length < 8)" class="text-danger">Al menos 8 caracteres</li>
                    <li *ngIf="form.controls['password'].value && form.controls['password'].value.length >= 8" class="text-success">Al menos 8 caracteres</li>
                    
                    <li *ngIf="form.controls['password'].dirty && hasUppercaseError()" class="text-danger">Al menos una letra mayúscula</li>
                    <li *ngIf="!hasUppercaseError() && form.controls['password'].value" class="text-success">Al menos una letra mayúscula</li>
                    
                    <li *ngIf="form.controls['password'].dirty && hasLowercaseError()" class="text-danger">Al menos una letra minúscula</li>
                    <li *ngIf="!hasLowercaseError() && form.controls['password'].value" class="text-success">Al menos una letra minúscula</li>
                    
                    <li *ngIf="form.controls['password'].dirty && hasDigitError()" class="text-danger">Al menos un número</li>
                    <li *ngIf="!hasDigitError() && form.controls['password'].value" class="text-success">Al menos un número</li>
                  </ul>
                </div>
                <app-form-errors [controlName]="form.controls['password']"></app-form-errors>
              </div>
            </div>

            <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12" *ngIf="wantToChangePassword">
              <div class="form-group mb-3">
                <label class="required-field">Confirmar nueva contraseña</label>
                <div>
                  <input formControlName="confirmPassword" type="password" class="form-control" />
                </div>
                <div *ngIf="form.controls['password'].value !== form.controls['confirmPassword'].value && form.controls['confirmPassword'].dirty" 
                   class="text-danger mt-1 small">
                  Las contraseñas no coinciden
                </div>
                <div *ngIf="form.controls['password'].value === form.controls['confirmPassword'].value && form.controls['confirmPassword'].value && form.controls['confirmPassword'].dirty" 
                   class="text-success mt-1 small">
                  Las contraseñas coinciden
                </div>
                <app-form-errors [controlName]="form.controls['confirmPassword']"></app-form-errors>
              </div>
            </div>
          </div>
          
        </div>
        <h5 class="mt-2 mb-2">
          Datos generales
        </h5>
        <div class="row">
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Tipo de Identificación</label>
              <div>
                <select formControlName="typeIdentificationId" class="form-control" (change)="onDocumentTypeChange()">
                  <option value="">Seleccione</option>
                  <option *ngFor="let item of typeIdentList" [value]="item.id">{{item.text}}</option>
                </select>
              </div>
              <app-form-errors [controlName]="form.controls['typeIdentificationId']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Numero de Identificación</label>
              <div>
                <input formControlName="identification" type="text" class="form-control" [mask]="documentMask" [validation]="false" />
              </div>
              <app-form-errors [controlName]="form.controls['identification']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Razón Social</label>
              <div>
                <input formControlName="razonSocial" type="text" class="form-control" />
              </div>
              <app-form-errors [controlName]="form.controls['razonSocial']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Nombre comercial</label>
              <div>
                <input formControlName="tradeName" type="text" class="form-control" />
              </div>
              <app-form-errors [controlName]="form.controls['tradeName']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-12 col-lg-8 col-md-12 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Actividad económica</label>
              <div>
                <select formControlName="economicActivityId" class="form-control">
                  <option value="">Seleccione</option>
                  <option *ngFor="let item of economicActList" [value]="item.id">{{item.text}}</option>
                </select>
              </div>
              <app-form-errors [controlName]="form.controls['economicActivityId']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Cantidad de empleados</label>
              <div class="input-group">
                <input formControlName="directEmployees" type="number" min="0" class="form-control" />
                <span class="input-group-text">Directos</span>
              </div>
              <app-form-errors [controlName]="form.controls['directEmployees']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Cantidad de empleados</label>
              <div class="input-group">
                <input formControlName="indirectEmployees" type="number" min="0" class="form-control" />
                <span class="input-group-text">Indirectos</span>
              </div>
              <app-form-errors [controlName]="form.controls['indirectEmployees']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label>Descripción de la empresa</label>
              <div>
                <textarea formControlName="companyDescription" class="form-control" rows="2"></textarea>
              </div>
              <app-form-errors [controlName]="form.controls['legalRepTypeIdentificationId']"></app-form-errors>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="card">
          <div class="card-body position-relative">
            <!-- Overlay de carga para el logo -->
            <div *ngIf="isLogoUploading" class="file-upload-overlay">
              <div class="file-upload-spinner"></div>
              <div class="file-upload-message">Subiendo logo...</div>
            </div>
            <!-- Overlay de error para el logo -->
            <div *ngIf="logoUploadError" class="file-upload-overlay file-upload-error">
              <i class="fa-solid fa-circle-exclamation fa-2x mb-2"></i>
              <div class="file-upload-message">{{ logoUploadError }}</div>
              <button class="btn btn-sm btn-light mt-2" (click)="logoUploadError = null">Cerrar</button>
            </div>
            <!-- Overlay de éxito para el logo -->
            <div *ngIf="logoUploadSuccess" class="file-upload-overlay file-upload-success">
              <i class="fa-solid fa-circle-check fa-2x mb-2"></i>
              <div class="file-upload-message">Logo subido correctamente</div>
              <button class="btn btn-sm btn-light mt-2" (click)="logoUploadSuccess = false">Cerrar</button>
            </div>
            <div class="d-flex align-items-center justify-content-center position-relative" style="min-height: 120px;">
              <img [src]="logoPreview || 'assets/Images/company.png'" onerror="this.src='assets/Images/company.png'; this.error=null;" alt="Compania" class="img-fluid" />
              <!-- Botón eliminar logo -->
              <button *ngIf="!isViewMode && (selectedLogoFile || (logoPreview && form.get('logoFileId')?.value))" type="button" class="btn btn-danger btn-sm position-absolute" style="top: 8px; right: 8px; border-radius: 50%; z-index: 10; padding: 4px 8px;" (click)="removeLogo()" title="Eliminar logo">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div *ngIf="!isViewMode && !isLogoUploading" class="position-absolute text-center w-100" style="bottom: 25px;" (click)="onLogoClick()">
              <button type="button" class="btn btn-primary">
                Subir logo
              </button>
            </div>
            <div class="d-none">
              <input type="file" accept="image/*,application/pdf" id="fileLogo" (change)="onLogoSelected($event)">
            </div>
          </div>
        </div>
        <h5 class="mt-2 mb-2">
          Documentos
        </h5>
        <div class="table-responsive position-relative">
          <!-- Overlay de carga para el documento -->
          <div *ngIf="isDocUploading" class="file-upload-overlay">
            <div class="file-upload-spinner"></div>
            <div class="file-upload-message">Subiendo documento...</div>
          </div>
          <!-- Overlay de error para el documento -->
          <div *ngIf="docUploadError" class="file-upload-overlay file-upload-error">
            <i class="fa-solid fa-circle-exclamation fa-2x mb-2"></i>
            <div class="file-upload-message">{{ docUploadError }}</div>
            <button class="btn btn-sm btn-light mt-2" (click)="docUploadError = null">Cerrar</button>
          </div>
          <!-- Overlay de éxito para el documento -->
          <div *ngIf="docUploadSuccess" class="file-upload-overlay file-upload-success">
            <i class="fa-solid fa-circle-check fa-2x mb-2"></i>
            <div class="file-upload-message">Documento subido correctamente</div>
            <button class="btn btn-sm btn-light mt-2" (click)="docUploadSuccess = false">Cerrar</button>
          </div>
          <div *ngIf="!isViewMode" class="alert alert-info mb-2">
            <i class="fa-solid fa-circle-info me-2"></i>
            Los documentos marcados como requeridos son obligatorios para guardar o crear la cuenta.
          </div>
          <table class="table table-theme">
            <thead>
              <tr>
                <th>Documento</th>
                <th class="text-center">Req.</th>
                <th width="120px" class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span class="required-field">Registro mercantil</span></td>
                <td class="text-center">
                  <div class="form-check d-inline-block">
                    <input class="form-check-input" type="checkbox" disabled checked>
                  </div>
                </td>
                <td class="text-center">
                  <div class="d-flex justify-content-center gap-2">
                    <button *ngIf="!isViewMode && !isDocUploading" type="button" class="btn btn-primary btn-sm" title="Subir" (click)="onDocReqClick(0)">
                      <i class="fa-solid fa-upload"></i>
                    </button>
                    <a *ngIf="mercantilePreview" href="{{mercantilePreview}}" target="_blank" class="btn btn-outline-info btn-sm" title="Ver documento">
                      <i class="fa-solid fa-eye"></i>
                    </a>
                    <!-- Botón eliminar registro mercantil -->
                    <button *ngIf="!isViewMode && (selectedMercantileFile || (mercantilePreview && form.get('mercantileRegistrationFileId')?.value))" type="button" class="btn btn-danger btn-sm ms-2" (click)="removeMercantile()" title="Eliminar documento">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td><span class="required-field">Cédula del representate legal</span></td>
                <td class="text-center">
                  <div class="form-check d-inline-block">
                    <input class="form-check-input" type="checkbox" disabled checked>
                  </div>
                </td>
                <td class="text-center">
                  <div class="d-flex justify-content-center gap-2">
                    <button *ngIf="!isViewMode && !isDocUploading" type="button" class="btn btn-primary btn-sm" title="Subir" (click)="onDocReqClick(1)">
                      <i class="fa-solid fa-upload"></i>
                    </button>
                    <a *ngIf="legalRepIdPreview" href="{{legalRepIdPreview}}" target="_blank" class="btn btn-outline-info btn-sm" title="Ver documento">
                      <i class="fa-solid fa-eye"></i>
                    </a>
                    <!-- Botón eliminar cédula representante -->
                    <button *ngIf="!isViewMode && (selectedLegalRepIdFile || (legalRepIdPreview && form.get('legalRepresentativeIDFileId')?.value))" type="button" class="btn btn-danger btn-sm ms-2" (click)="removeLegalRepId()" title="Eliminar documento">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-none">
          <input type="file" accept="image/*,application/pdf" id="fileDocReq" (change)="onDocReqSelected($event)">
        </div>
      </div>
    </div>
    <hr class="mt-3 mb-3" />
    <h5 class="mt-2 mb-2">
      Representante legal
    </h5>
    <div class="row">
      <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="row">
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Tipo de Identificación</label>
              <div>
                <select formControlName="legalRepTypeIdentificationId" class="form-control" (change)="onDocumentLegalRepTypeChange()">
                  <option value="">Seleccione</option>
                  <option *ngFor="let item of typeIdentList" [value]="item.id">{{item.text}}</option>
                </select>
              </div>
              <app-form-errors [controlName]="form.controls['legalRepTypeIdentificationId']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Numero de Identificación</label>
              <div>
                <input formControlName="legalRepIdentification" type="text" class="form-control" [mask]="documentLegalRepMask" [validation]="false" />
              </div>
              <app-form-errors [controlName]="form.controls['legalRepIdentification']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Nombre</label>
              <div>
                <input formControlName="legalRepFirstName" type="text" class="form-control" />
              </div>
              <app-form-errors [controlName]="form.controls['legalRepFirstName']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Apellido</label>
              <div>
                <input formControlName="legalRepLastName" type="text" class="form-control" />
              </div>
              <app-form-errors [controlName]="form.controls['legalRepLastName']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Fecha de nacimiento</label>
              <div>
                <input formControlName="legalRepBirthDate" type="date" class="form-control" />
              </div>
              <app-form-errors [controlName]="form.controls['legalRepBirthDate']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Edad</label>
              <div>
                <input [value]="legalRepAge" type="text" class="form-control" readonly="readonly" />
                <div *ngIf="birthDate.invalid && (birthDate.dirty || birthDate.touched)" class="text-danger">
                  <div *ngIf="birthDate.errors!['underage']">Debe tener al menos {{minAge}} años.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Teléfono principal</label>
              <div class="d-flex align-items-center gap-2">
              @if (isCountriesDropdownVisible) {
                <app-country-list-dropdown [code]="useRDMask.primary.code" class="form-control p-0" [disabled]="isViewMode"
                    style="max-width: 160px;" formControlName="primaryPhoneData" (countryChange)="onCountryChange($event, 'primary')"></app-country-list-dropdown>
              }
              <div>
                @if (useRDMask.primary.enabled) {
                  <input mask="(000) 000-0000" formControlName="legalRepPrimaryPhone" type="text" class="form-control" />
                }
                @else {
                  <input appNumbersOnly formControlName="legalRepPrimaryPhone" type="text" class="form-control" />
                }
              </div>
              </div>
              <app-form-errors [controlName]="form.controls['legalRepPrimaryPhone']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Teléfono secundario</label>
              <div class="d-flex align-items-center gap-2">
                @if (isCountriesDropdownVisible) {
                  <app-country-list-dropdown
                    formControlName="secondaryPhoneData"
                    (countryChange)="onCountryChange($event, 'secondary')"
                    class="form-control p-0"
                    style="max-width: 160px;" [code]="useRDMask.secondary.code" [disabled]="isViewMode"
                  ></app-country-list-dropdown>
                }

                <div class="flex-grow-1">
                  @if (useRDMask.secondary.enabled) {
                    <input
                      mask="(000) 000-0000"
                      formControlName="legalRepSecondaryPhone"
                      type="text"
                      class="form-control "
                    />
                  }
                  @else {
                    <input appNumbersOnly
                      formControlName="legalRepSecondaryPhone"
                      type="text"
                      class="form-control"
                    />
                  }
                </div>
              </div>

              <app-form-errors [controlName]="form.controls['legalRepSecondaryPhone']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Celular a</label>
              <div class="d-flex align-items-center gap-2">
              @if (isCountriesDropdownVisible) {
                <app-country-list-dropdown class="form-control p-0" [code]="useRDMask.cel.code" [disabled]="isViewMode"
                    style="max-width: 160px;" formControlName="cellPhoneData" (countryChange)="onCountryChange($event, 'cel')"></app-country-list-dropdown>
              }
              <div class="input-group ">
                <div class="input-group-text">
                  <input class="form-check-input mt-0" type="checkbox" formControlName="legalRepCellPhoneHasWhatsapp" >
                  <i class="fa-brands fa-whatsapp mx-2"></i>
                </div>
                @if (useRDMask.cel.enabled) {
                <input mask="(000) 000-0000" formControlName="legalRepCellPhone" type="text" class="form-control" />
                }
                @else {
                <input appNumbersOnly formControlName="legalRepCellPhone" type="text" class="form-control" />

                }
              </div>
              </div>
              <app-form-errors [controlName]="form.controls['legalRepCellPhone']"></app-form-errors>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="card">
          <div class="card-body position-relative">
            <!-- Overlay de carga para la foto del representante -->
            <div *ngIf="isRepPhotoUploading" class="file-upload-overlay">
              <div class="file-upload-spinner"></div>
              <div class="file-upload-message">Subiendo foto...</div>
            </div>
            <!-- Overlay de error para la foto del representante -->
            <div *ngIf="repPhotoUploadError" class="file-upload-overlay file-upload-error">
              <i class="fa-solid fa-circle-exclamation fa-2x mb-2"></i>
              <div class="file-upload-message">{{ repPhotoUploadError }}</div>
              <button class="btn btn-sm btn-light mt-2" (click)="repPhotoUploadError = null">Cerrar</button>
            </div>
            <!-- Overlay de éxito para la foto del representante -->
            <div *ngIf="repPhotoUploadSuccess" class="file-upload-overlay file-upload-success">
              <i class="fa-solid fa-circle-check fa-2x mb-2"></i>
              <div class="file-upload-message">Foto subida correctamente</div>
              <button class="btn btn-sm btn-light mt-2" (click)="repPhotoUploadSuccess = false">Cerrar</button>
            </div>
            <div class="d-flex align-items-center justify-content-center position-relative" style="min-height: 120px;">
              <img [src]="repPhotoPreview || 'assets/Images/user.png'" alt="Compania" class="img-fluid" />
              <!-- Botón eliminar foto representante -->
              <button *ngIf="!isViewMode && (selectedRepPhotoFile || (repPhotoPreview && form.get('legalRepPhotoFileId')?.value))" type="button" class="btn btn-danger btn-sm position-absolute" style="position: absolute; top: 8px; right: 8px; z-index: 2; 
       border-radius: 50%; width: 32px; height: 32px; 
       display: flex; align-items: center; justify-content: center;" (click)="removeRepPhoto()" title="Eliminar foto">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div *ngIf="!isViewMode && !isRepPhotoUploading" class="position-absolute text-center w-100" style="bottom: 25px;" (click)="onRepPhotoClick()">
              <button type="button" class="btn btn-primary">
                Subir foto
              </button>
            </div>
            <div class="d-none">
              <input type="file" accept="image/*,application/pdf" id="fileFoto" (change)="onRepPhotoSelected($event)">
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row mb-2">
        <div class="col-6">
          <h5 class="mt-2 mb-2">
            Domicilio
          </h5>
        </div>
        <div class="col-6">
          <div class="text-end">
            <button *ngIf="!isViewMode" type="button" class="btn btn-outline-primary btn-sm" (click)="openAddressDialog()">
              <i class="fa-regular fa-square-plus"></i>
              Nuevo
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-theme">
          <thead>
            <tr>
              <th>País</th>
              <th>Estado/Provincia</th>
              <th>Municipio/Ciudad</th>
              <th>Sector/Barrio</th>
              <th>Calle</th>
              <th>Principal</th>
              <th width="180px"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let addr of visibleAddresses; let i = index">
              <td>{{ addr.countryName }}</td>
              <td>{{ addr.stateName }}</td>
              <td>{{ addr.city }}</td>
              <td>{{ addr.districtName ?? 'N/A' }}</td>
              <td>{{ addr.address }}</td>
              <td>
                <i *ngIf="addr.isPrimary" class="fa-regular fa-circle-check text-success fa-lg"></i>
              </td>
              <td class="d-flex align-items-center justify-content-center">
                <button *ngIf="!isViewMode" type="button" class="btn btn-outline-success me-2" (click)="editAddress(addr, i)">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button type="button" class="btn btn-outline-info me-2" (click)="viewAddress(addr)">
                  <i class="fa-solid fa-eye"></i>
                </button>
                <button *ngIf="!isViewMode" type="button" class="btn btn-outline-danger" (click)="removeAddress(i)">
                  <i class="fa-regular fa-trash-can"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
    <h5 class="mt-2 mb-2" *ngIf="!isEditMode && !isViewMode">
      Accesos
    </h5>
    <div class="row" *ngIf="!isEditMode && !isViewMode">
      <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="form-group mb-3">
          <label class="required-field">Contraseña</label>
          <div>
            <input formControlName="password" type="password" class="form-control" />
          </div>
          <!-- Requisitos de contraseña -->
          <div class="password-requirements mt-2"
            [ngClass]="{'text-danger': form.controls['password'].dirty && form.controls['password'].invalid}">
            <small>
              La contraseña debe cumplir los siguientes requisitos:
            </small>
            <ul class="small mt-1 ps-3">
              <li
                *ngIf="form.controls['password'].dirty && (!form.controls['password'].value || form.controls['password'].value.length < 8)"
                class="text-danger">Al menos 8 caracteres</li>
              <li *ngIf="form.controls['password'].value && form.controls['password'].value.length >= 8"
                class="text-success">Al menos 8 caracteres</li>
    
              <li *ngIf="form.controls['password'].dirty && hasUppercaseError()" class="text-danger">Al menos una letra
                mayúscula</li>
              <li *ngIf="!hasUppercaseError() && form.controls['password'].value" class="text-success">Al menos una letra
                mayúscula</li>
    
              <li *ngIf="form.controls['password'].dirty && hasLowercaseError()" class="text-danger">Al menos una letra
                minúscula</li>
              <li *ngIf="!hasLowercaseError() && form.controls['password'].value" class="text-success">Al menos una letra
                minúscula</li>
    
              <li *ngIf="form.controls['password'].dirty && hasDigitError()" class="text-danger">Al menos un número</li>
              <li *ngIf="!hasDigitError() && form.controls['password'].value" class="text-success">Al menos un número</li>
            </ul>
          </div>
          <app-form-errors [controlName]="form.controls['password']"></app-form-errors>
        </div>
      </div>
    
      <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="form-group mb-3">
          <label class="required-field">Confirmar contraseña</label>
          <div>
            <input formControlName="confirmPassword" type="password" class="form-control" />
          </div>
          <div
            *ngIf="form.controls['password'].value !== form.controls['confirmPassword'].value && form.controls['confirmPassword'].dirty"
            class="text-danger mt-1 small">
            Las contraseñas no coinciden
          </div>
          <div
            *ngIf="form.controls['password'].value === form.controls['confirmPassword'].value && form.controls['confirmPassword'].value && form.controls['confirmPassword'].dirty"
            class="text-success mt-1 small">
            Las contraseñas coinciden
          </div>
          <app-form-errors [controlName]="form.controls['confirmPassword']"></app-form-errors>
        </div>
      </div>
    </div>
    <hr class="mt-2 mb-2" />
    <br />
    <p class="mt-2 mb-2">
      Con mi cuenta de RedLaboralRD deseo:
    </p>
    <div class="row">
      <div class="col-12 mb-2">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" formControlName="wantToPublishOffers" id="redLaboralOpcion1">
          <label class="form-check-label" for="redLaboralOpcion1">
            <span class="fw-medium">Publicar ofertas de empleo y buscar posibles candidatos</span>
          </label>
        </div>
      </div>
      <div class="col-12" *ngIf="isEditMode">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" formControlName="hidePublicNameAndLogo" id="redLaboralOpcion2">
          <label class="form-check-label" for="redLaboralOpcion2">
            <span class="fw-medium">Ocultar el nombre de la empresa y el logo en mis ofertas laborales</span>
          </label>
        </div>
      </div>
    </div>
    <br />
    <hr class="mt-2 mb-2" />
    <div class="mt-4 mb-3" *ngIf="showSaveRegister">
      <div class="card shadow-sm border-primary">
        <div class="card-body">
          <h6 class="mb-3 text-primary"><i class="fa-solid fa-circle-info me-2"></i>Términos legales</h6>
          <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" formControlName="privacityTermsAccepted" id="PoliticaPrivacidadRegister">
            <label class="form-check-label" for="PoliticaPrivacidadRegister">
              Acepto la <a href="javascript:void(0);" class="text-decoration-none fw-bold" data-bs-toggle="modal" data-bs-target="#modalPoliticaPrivacidad">política de privacidad</a>
            </label>
          </div>
          <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" formControlName="refundTermsAccepted" id="TerminosCondicionesRegister">
            <label class="form-check-label" for="TerminosCondicionesRegister">
              Acepto los <a href="javascript:void(0);" class="text-decoration-none fw-bold" data-bs-toggle="modal" data-bs-target="#modalTerminosCondiciones">términos y condiciones</a>
            </label>
          </div>
        </div>
      </div>
      <div class="text-end mt-3">
        <button type="button" class="btn btn-primary btn-lg" (click)="onSubmit()">
          Crear cuenta
        </button>
      </div>
    </div>
    <div class="mt-2 mb-2 text-end" *ngIf="showSaveButton">
      <button type="button" class="btn btn-primary btn-lg" (click)="onSubmit()">
        Guardar
      </button>
    </div>
  </ng-template>
  </div>
  
<!-- Modal Términos y Condiciones -->
<div class="modal fade" id="modalTerminosCondiciones" tabindex="-1" aria-labelledby="modalTerminosCondicionesLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalTerminosCondicionesLabel">Términos y condiciones</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="text-justify">
          Al utilizar RedLaboralRD, usted acepta cumplir con nuestras condiciones de uso. Los usuarios deben proporcionar información verídica y actualizada. RedLaboralRD se reserva el derecho de modificar estas condiciones en cualquier momento. El uso continuado de la plataforma después de cualquier modificación constituye la aceptación de dichos cambios. No está permitido el uso indebido de la información disponible en la plataforma ni el intento de vulnerar la seguridad del sistema. El incumplimiento de estos términos podría resultar en la suspensión o eliminación de la cuenta.
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Modal Política de Privacida -->
<div class="modal fade" id="modalPoliticaPrivacidad" tabindex="-1" aria-labelledby="modalPoliticaPrivacidadLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalPoliticaPrivacidadLabel">Política de privacidad</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="text-justify">
          POLÍTICA DE PRIVACIDAD DE REDLABORALRD <br>
          Fecha de última actualización: 11 de julio de 2025<br><br>
          En Redlaboralrd, valoramos su privacidad y nos comprometemos a proteger sus datos personales. Esta Política de Privacidad describe cómo recopilamos, usamos, procesamos y compartimos su información cuando utiliza nuestra plataforma.<br><br>
          <strong>1. Información que Recopilamos</strong><br>
          <strong>1.1. Información que usted nos proporciona directamente:</strong><br>
          <u>Para Colaboradores:</u> Datos de registro (nombre completo, correo, teléfono, etc.), información curricular, contenido de comunicaciones.<br>
          <u>Para Empresas:</u> Datos de registro (nombre, RNC, contacto, etc.), perfil de empresa, datos de ofertas laborales.<br><br>
          <strong>1.2. Información recopilada automáticamente:</strong><br>
          Datos de uso, técnicos, cookies y tecnologías similares.<br><br>
          <strong>2. Finalidad del Tratamiento de Datos</strong><br>
          Proveer y mantener la plataforma, personalizar experiencia, mejorar servicios, comunicación, seguridad, cumplimiento legal.<br><br>
          <strong>3. Compartición de Información</strong><br>
          Entre usuarios, proveedores de servicios, requerimientos legales, transferencias de negocio y con su consentimiento.<br><br>
          <strong>4. Responsabilidad</strong><br>
          Redlaboralrd actúa como intermediario. Las partes (colaborador y empresa) son responsables de sus datos compartidos.<br><br>
          <strong>5. Seguridad</strong><br>
          Aplicamos medidas de seguridad razonables, pero no garantizamos protección absoluta.<br><br>
          <strong>6. Retención de Datos</strong><br>
          Conservamos información según la necesidad legal y operativa.<br><br>
          <strong>7. Derechos del Usuario</strong><br>
          Acceder, rectificar, eliminar, oponerse al tratamiento, revocar consentimiento.<br><br>
          <strong>8. Cambios a la Política</strong><br>
          Podemos actualizar esta política. Notificaremos los cambios importantes.<br><br>
          <strong>9. Contacto</strong><br>
          Si tiene preguntas, contáctenos a través de [correo de Redlaboralrd] o [teléfono].
        </p>
      </div>
    </div>
  </div>
</div>
